import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAvatarPresignedURL } from '@common/api/api';
import { log, LOG_LEVELS } from '../../common/config/app_logger';
import { updateUser } from '../actions/user';

export const useUploadUserAvatar = () => {
  const dispatch = useDispatch<any>();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const uploadUserAvatar = async (file: File) => {
    setLoading(true);

    try {
      const res = await getAvatarPresignedURL();
      const { presignedUrlKey, presignedUrl } = res;
      log(LOG_LEVELS.INFO, 'Amazon', 'uploading user avatar');
      const response = await fetch(presignedUrl, {
        method: 'PUT',
        headers: { 'Content-Type': 'image/jpeg' },
        body: file
      });

      if (response.ok) {
        dispatch(updateUser({ avatarUid: presignedUrlKey }));
        setSuccess(true);
        log(LOG_LEVELS.INFO, 'Amazon', 'avatar upload success');
      } else {
        log(LOG_LEVELS.ERROR, 'Amazon', `Avatar upload failed with status: ${ response.status }`);
      }
    } catch (uploadError) {
      log(LOG_LEVELS.ERROR, 'Amazon', 'uploading user avatar error:', uploadError);
    } finally {
      setLoading(false);
    }
  };

  return {
    uploadUserAvatar,
    loading,
    success,
    setSuccess
  };
};
